<script setup lang="ts">

import Button from 'primevue/button'


</script>

<template>
  <Button v-bind="$attrs"  :pt="{root:{class:'button'}}">
    <template v-for="(_, slot) in $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </Button>
</template>

<style scoped>


</style>